const getFormattedSizeBytes = (maxSizeBytes) => {
  const kilo = 1024;
  const exponent = Math.floor(Math.log(maxSizeBytes) / Math.log(kilo));
  const formattedResult = new Intl.NumberFormat("ko-KR").format(
    maxSizeBytes / Math.pow(kilo, exponent)
  );
  const unit = ["B", "KB", "MB", "GB", "TB"][exponent];
  return formattedResult + unit;
};

export { getFormattedSizeBytes };
//# sourceMappingURL=getFileSize.mjs.map
